import API from "services";
import { useQuery } from "react-query";
import {
  IDashboard,
  IDashboardSetting,
  IGetDashboardSettingsResponseData,
  IPublicDashboard,
} from "shared/types/dashboardManagement";

const generatePublicLookerIframe = async (
  dashboard?: IPublicDashboard | null,
) => {
  if (!dashboard?.id) {
    return "";
  }
  try {
    return await API.services.metrics.generatePublicLookerIframe(dashboard.id);
  } catch (error) {
    if (error instanceof Error) {
      throw Error(error.message);
    }
    throw Error("Unknown error occurred while generating looker iframe.");
  }
};

export const useFetchPublicLookerIframe = (
  dashboard?: IPublicDashboard | null,
) => {
  return useQuery<string, Error>(
    ["metrics", dashboard],
    () => generatePublicLookerIframe(dashboard),
    {
      enabled: !!dashboard,
      staleTime: Infinity,
    },
  );
};

const generateLookerIframe = async (
  dashboard?: IDashboard | null,
  dashboardSettings?: IDashboardSetting[] | null,
) => {
  if (!dashboard?.id) {
    return "";
  }
  try {
    const result = await API.services.metrics.generateLookerIframe<string>(
      dashboard.id,
      dashboardSettings,
    );
    return result;
  } catch (error) {
    if (error instanceof Error) {
      throw Error(error.message);
    }
    throw Error("Unknown error occurred while generating looker iframe.");
  }
};

const useFetchLookerIframe = (
  dashboard?: IDashboard | null,
  dashboardSettings?: IGetDashboardSettingsResponseData | null,
) => {
  return useQuery<string, Error>(
    ["metrics", dashboard],
    () => generateLookerIframe(dashboard, dashboardSettings?.dashboardSettings),
    {
      enabled: !!dashboard && dashboardSettings !== undefined,
      staleTime: Infinity,
    },
  );
};

export default useFetchLookerIframe;
